

export default class StatsService {

    constructor(http){
        this.http = http;
    }


    getByHour(){
        return this.http.get('/api/jobs/stats/per-hour').then(({ data }) => {
            return data;
        });
    }

    getTimeConsumingByQueue(){
        return this.http.get('/api/jobs/stats/queue-time-consuming').then(({ data }) => {
            return data;
        });
    }

    getTimeConsumingByClass(){
        return this.http.get('/api/jobs/stats/class-time-consuming').then(({ data }) => {
            return data;
        });
    }

    getJobsPerQueue(){
        return this.http.get('/api/jobs/stats/jobs-per-queue').then(({ data }) => {
            return data;
        });
    }

    getErrorsPerQueue(){
        return this.http.get('/api/jobs/stats/errors-per-queue').then(({ data }) => {
            return data;
        });
    }

    getErrorRate(){
        return this.http.get('/api/jobs/stats/error-rate').then(({ data }) => {
            return data;
        });

    }

    getLastErrorsGrouped() {
        return this.http.get('/api/jobs/stats/last-errors-grouped');
    }

    getErrorsByName(params) {
        return this.http.get('/api/jobs/stats/last-errors-by-class', {params});
    }

}


// WEBPACK FOOTER //
// ./src/services/stats.service.js